// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"69cbd3fb","135":"ca7b19de","453":"36012b8c","680":"b5fbf09a","773":"e9ed5b86"}[chunkId] + ".chunk.js";
};